import { Box, ButtonPrimary, IconCheckedLight, skinVars, Text3, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import { FeedbackContainer, ScreenResponsive } from "../../components";
import { strings } from "../../localization";
import { useNavigateCustom } from "../../hooks";

const PasswordChangeSuccess: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { title, description, button } = strings.pages.passwordChangeSuccess;

	return (
		<ScreenResponsive onBack={() => navigate(-1)} navigationTitle={strings.pages.navigation.anticipation}>
			<Box paddingX={8}>
				<FeedbackContainer
					icon={<IconCheckedLight size={64} color={skinVars.colors.success} />}
					title={title}
					description={description}
				>
					<ButtonPrimary
						onPress={() => alert("pressed")}
						showSpinner={false}
						disabled={false}
						style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
					>
						<Text3 medium color={skinVars.colors.textButtonPrimary}>
							{button}
						</Text3>
					</ButtonPrimary>
				</FeedbackContainer>
			</Box>
		</ScreenResponsive>
	);
});

export default PasswordChangeSuccess;
